import React, { Component } from 'react';
import { ProductConsumer } from '../context';
import { Link } from 'react-router-dom';
import { ButtonContainer } from './StyledComponents';

export default class Details extends Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const { id, company, img, info, price, title, inCart } = value.detailProduct;
          return (
            <div className="productDetailContainer">
              {/* title */}
              <div className="productDetailRow">
                <div className="productDetailColumn">
                  <h1>{title}</h1>
                </div>
              </div>
              {/* end title */}
              {/* product info */}
              <div className="productInfoRow">
                <div className="productInfoColumn">
                  <img src={img} alt="productImage" className="productImage" />
                </div>
                {/* product text */}
                <div className="productTextColumn">
                  <h2>Model : {title}</h2>
                  <h4 className="productMadeBy">Made By : {company}</h4>
                  <h4 className="productDetailPrice">Price : ${price}</h4>
                  <p className="someInfo">Some Info About Product:</p>
                  <p className="productInfoText">{info}</p>
                  {/* buttons */}
                  <div className="detailButtons">
                    <Link to="/">
                      <ButtonContainer>Back To Products</ButtonContainer>
                    </Link>
                    <ButtonContainer
                        cart
                        disabled={inCart ? true : false}
                        onClick={() => {
                          value.addToCart(id);
                          value.openModal(id);
                        }}>
                          {inCart ? "In Cart" : "Add To Cart"}
                      </ButtonContainer>
                  </div>
                </div>
              </div>
              {/* end product info */}
            </div>
          );
        }}
      </ProductConsumer>
    )
  }
}
